<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="row">
        <div class="col-sm-12 text-center">
          {{new Date().getFullYear()}} © {{$t("ppp_loan_tracker")}}.
        </div>
      </div>
    </div>
  </footer>
</template>
